module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f320.7c342332.svg";